import { Fragment } from 'react';
// import { Picture } from '@/components';
import clsx from 'clsx';

import styles from '../Shop.module.scss';

const SideShop = props => {
	const { address, phones, store_hours, name, image } = props;

	return (
		<div className={clsx(styles.side, styles.sideShop)}>
			<h3 className={styles.title}>{name}</h3>
			{address && (
				<dl className={styles.prop}>
					<dt>Адрес: </dt>
					<dd>{address}</dd>
				</dl>
			)}
			{phones && phones.length > 0 && (
				<dl className={styles.prop}>
					<dt>{phones.length > 1 ? 'Телефоны: ' : 'Телефон: '}</dt>
					<dd>
						{phones.map((phone, ind) => {
							const { normal, prettified } = phone;
							return (
								<Fragment key={normal}>
									<a href={`tel:${normal}`}>{prettified}</a>
									{phones.length > 1 && ind < phones.length - 1 && ', '}
								</Fragment>
							);
						})}
					</dd>
				</dl>
			)}
			{store_hours && store_hours.length > 0 && (
				<dl className={styles.prop}>
					<dt>Открыто:</dt>
					<dd>
						{store_hours.map(data => (
							<p key={data}>{data}</p>
						))}
					</dd>
				</dl>
			)}
		</div>
	);
};

export default SideShop;
